export const COMPANY_NAME = "Unggul Indonesia Maju";
export const LANGUAGES = {
  EN: "en",
  ID: "id"
}; 